"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var animation_1 = require("@arwes/animation");
var Table_component_1 = require("./Table.component");
var Table_animator_1 = require("./Table.animator");
// TODO: Fix props or HOC to properly use nested component props with withAnimator.
var Table = animation_1.withAnimator(Table_animator_1.animator)(Table_component_1.Table);
exports.Table = Table;
